import { error, finish } from '../../../modules/selections/actions/unsettle';
import { request as refreshEvent } from '../../../modules/events/actions/get';
import api from '../../../api';

export function request(dispatch, { id, eventId, marketId }) {
    api.post(`/events/${eventId}/markets/${marketId}/selections/${id}/unsettle`).then(
        (selection) => {
            dispatch(finish(id, selection));
            dispatch(refreshEvent(eventId));
        },
        (errors) => dispatch(error(id, errors))
    );
}
